import { createAction } from '@reduxjs/toolkit';

export const setPanelsList = createAction('form/setPanelsList', (panelsList) => ({
  payload: {
    panelsList,
  },
}));

export const setPostsList = createAction('form/setPostsList', (postsList) => ({
  payload: {
    postsList,
  },
}));

export const setCornerPostsList = createAction('form/setCornerPostsList', (cornerPostsList) => ({
  payload: {
    cornerPostsList,
  },
}));

export const setAccessoryList = createAction('form/setAccessoryList', (accessoryList, level) => ({
  payload: {
    accessoryList,
    level,
  },
}));

export const setCornerPostAccessoryList = createAction('form/setCornerPostAccessoryList', (accessoryList, level) => ({
  payload: {
    accessoryList,
    level,
  },
}));

export const setCornerAccessoryList = createAction('form/setCornerAccessoryList', (accessoryList, level) => ({
  payload: {
    accessoryList,
    level,
  },
}));

export const setTreeStructureSettings = createAction('form/setTreeStructureSettings', (level, parentId, parentName) => ({
  payload: {
    level,
    parentId,
    parentName,
  },
}));

export const setAddedProducts = createAction('form/setAddedProducts', (uniqueAccessory) => ({
  payload: {
    uniqueAccessory,
  },
}));

export const fetchFilters = createAction('form/fetchFilters');

export const fetchColors = createAction('form/fetchColors', (filters) => ({
  payload: {
    filters,
  },
}));

export const setColors = createAction('form/setColors', (colors) => ({
  payload: {
    colors,
  },
}));

export const fetchTypes = createAction('form/fetchTypes', (filters) => ({
  payload: {
    filters,
  },
}));

export const setTypes = createAction('form/setTypes', (types) => ({
  payload: {
    types,
  },
}));

export const fetchHeights = createAction('form/fetchHeights', (filters) => ({
  payload: {
    filters,
  },
}));

export const setHeights = createAction('form/setHeights', (heights) => ({
  payload: {
    heights,
  },
}));

export const fetchProductsBySection = createAction('form/fetchProductsBySection', (
  fetchSettings,
) => ({
  payload: {
    fetchSettings,
  },
}));

export const setInputDataToSend = createAction('form/setInputDataToSend', (key, data) => ({
  payload: {
    key,
    data,
  },
}));

export const setNecessaryProductsQuantity = createAction('form/setNecessaryProductsQuantity', (productsWithQuantity) => ({
  payload: {
    productsWithQuantity,
  },
}));

export const calculateProductsQuantity = createAction('form/calculateProductsQuantity', (distance, panel, post, cornerPost, cornersQuantity, openingsQuantity, accessories, doublePost) => ({
  payload: {
    distance,
    panel,
    post,
    cornerPost,
    cornersQuantity,
    openingsQuantity,
    accessories,
    doublePost,
  },
}));
